// src/com/user_info/InformForgotPassword.js
import { Link, Paper } from "@mui/material";


export default function InformForgotPassword() {
    return(
        <Paper style={{backgroundColor:"#cef",padding:10}} >
            <div>암호를 잊은 경우 아래 이메일로 아이디, 이름, 소속, 변경할 암호를 발송</div>
            <div>이명호 : <Link to='#'
                            onClick={(e) => {
                                window.location = "mailto:chch0118@homeplus.co.kr";
                                e.preventDefault();
                            }} >chch0118@homeplus.co.kr</Link>
            </div>
            <div>이희청 : <Link to='#'
                            onClick={(e) => {
                                window.location = "mailto:e_hclee916@homeplus.co.kr";
                                e.preventDefault();
                            }} >e_hclee916@homeplus.co.kr</Link></div>
        </Paper>
    );
}